import Vue from 'vue'
import Router from 'vue-router'
import ListView from '@/views/ListView.vue'
import ShopView from '@/views/ShopView.vue'

Vue.use(Router)

export const router = new Router({
  mode: 'history',

  routes: [
    {
      path: '/',
      name: 'list',
      component: ListView,
      children: [{
        path: 'shop/:id',
        name: 'shop',
        component: ShopView,
        props: true
      }]
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpack-chunk-name: 'about' */ '@/views/ViewAbout')
    },
    {
      path: '/impressum',
      name: 'impressum',
      component: () => import(/* webpack-chunk-name: 'about' */ '@/views/ViewImpressum')
    },
    {
      path: '/datenschutz',
      name: 'datenschutz',
      component: () => import(/* webpack-chunk-name: 'about' */ '@/views/ViewDatenschutz')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/FormView.vue')
    },
    {
      path: '/eintragen/',
      name: 'eintragen',
      component: () => import('@/views/FormView.vue')
    }
  ]
})
